<template>
    <div class="price-range-container">
        <div class="price-range-title">
            <div class='filter-option-title'>Price Range</div>
            <!-- <div class="price-range-span">
                <span>{{min_price}}</span> - <span>{{max_price}}</span>
            </div> -->
        </div>
        <div>
            <div class="range-slider">
                <span class="slider-track"></span>
                <input type="range" name="min_val" class="min-val" :min="min" :max="max" v-model="min_value" @input="slideMin">
                <input type="range" name="max_val" class="max-val" :min="min" :max="max" v-model="max_value" @input="slideMax">
            </div>
            <div class="input-box">
                <div class="min-box">
                    <div class="input-wrap">
                        <span class="input-addon">£</span>
                        <input type="text" name="min_input" class="input-field min-input" v-model="min_input_value" @change="setMinInput">
                    </div>
                </div>
                <div class="max-box">
                    <div class="input-wrap">
                        <span class="input-addon">£</span>
                        <input type="text" name="max_input" class="input-field max-input" v-model="max_input_value" @change="setMaxInput">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['min_price', 'max_price', 'price_filter_watcher'],
    emits: ['filterPrice'],
    data(){
        return {
            min_value: this.min_price,
            max_value: this.max_price,
            min_input_value: this.min_price,
            max_input_value: this.max_price,
            min: this.min_price,
            max: this.max_price,
            min_gap: 5,
            slider_timeout: null,
        }
    },
    methods: {
        slideMin() {
            clearTimeout(this.slider_timeout);
            this.slider_timeout = setTimeout(() => {
                let gap = parseInt(this.max_value) - parseInt(this.min_value);
                if(gap <= this.min_gap) {
                    this.min_value = parseInt(this.max_value) - this.min_gap;
                }
                this.min_input_value = this.min_value;
                this.setArea();
                this.updateFilterPrice();
            }, 500);
        },
        slideMax() {
            clearTimeout(this.slider_timeout);
            this.slider_timeout = setTimeout(() => {
                let gap = parseInt(this.max_value) - parseInt(this.min_value);
                if(gap <= this.min_gap) {
                    this.max_value = parseInt(this.min_value) + this.min_gap;
                }
                this.max_input_value = this.max_value;
                this.setArea();
                this.updateFilterPrice();
            }, 500);
        },
        setArea() {
            const range = document.querySelector(".slider-track");
            const sliderMinValue = parseInt(this.min);
            const sliderMaxValue = parseInt(this.max);
            
            range.style.left = `${
                ((this.min_value - sliderMinValue) / (sliderMaxValue - sliderMinValue)) * 100
            }%`;

            //range.style.left = (this.min_value / sliderMaxValue) * 100 + "%";
            range.style.right = `${
                100 -
                ((this.max_value - sliderMinValue) / (sliderMaxValue - sliderMinValue)) * 100
            }%`;
            //range.style.right = 100 - (this.max_value / sliderMaxValue) * 100 + "%";
        },
        setMinInput() {
            const sliderMinValue = parseInt(this.min);

            let minPrice = parseInt(this.min_input_value);
            if(minPrice < sliderMinValue) {
                this.min_input_value = sliderMinValue;
            }
            this.min_value = this.min_input_value;
            this.slideMin();
            this.updateFilterPrice();
        },
        setMaxInput() {
            const sliderMaxValue = parseInt(this.max);

            let maxPrice = parseInt(this.max_input_value);
            if(maxPrice > sliderMaxValue) {
                this.max_input_value = sliderMaxValue;
            }
            this.max_value = this.max_input_value;
            this.slideMax();
            this.updateFilterPrice();
        },
        updateFilterPrice() {
            this.$emit('filterPrice', this.min_input_value, this.max_input_value);
        }
    },
    watch: {
        'price_filter_watcher' : function() {
            this.min_value       = this.min_price;
            this.max_value       = this.max_price;
            this.min_input_value = this.min_price;
            this.max_input_value = this.max_price;
            this.min             = this.min_price;
            this.max             = this.max_price;
            this.setArea();
        }
    },
    mounted() {
        this.setArea();
    },
}
</script>
<style scoped lang='scss'>
.price-range-container {
    display: flex;
    flex-direction: column;
    margin-top: 15px;
    gap: 1px;
}
.price-range-title{
    display:flex;
    justify-content: space-between;
}
.filter-option-title{
    font-size: 0.9rem;
    font-weight: 400;
}
.range-slider {
    position: relative;
    width: 100%;
    height: 5px;
    margin: 30px 0;
    background-color: #8a8a8a;
}

.slider-track {
    height: 100%;
    position: absolute;
    background-color: var(--primary-colour-1);
}

.range-slider input {
    position: absolute;
    width: 100%;
    background: none;
    pointer-events: none;
    top: 50%;
    transform: translateY(-50%);
    appearance: none;
}

input[type="range"]::-webkit-slider-thumb {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    border: 3px solid #FFF;
    background: #FFF;
    pointer-events: auto;
    appearance: none;
    cursor: pointer;
    box-shadow: 0 .125rem .5625rem -0.125rem rgba(0, 0, 0, .4);
    margin-top: -4px;
    margin-left: -2px;
}

input[type="range"]::-moz-range-thumb {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    border: 3px solid #FFF;
    background: #FFF;
    pointer-events: auto;
    -moz-appearance: none;
    cursor: pointer;
    box-shadow: 0 .125rem .5625rem -0.125rem rgba(0, 0, 0, .25);
}


.input-box {
    display: flex;
}

.min-box,
.max-box {
    width: 50%;
}

.min-box {
    padding-right: .5rem;
    margin-right: .5rem;
}

.input-wrap {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
}

.input-addon{
    display: flex;
    align-items: center;
    padding: .625rem 1rem;
    font-size: 0.9375rem;
    font-weight: 400;
    line-height: 1.5;
    color: #4b566b;
    text-align: center;
    white-space: nowrap;
    background-color: #FFF;
    border: 1px solid #d4d7e5;
    border-radius: .25rem;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
.input-field{
   margin-left: -1px;
   padding: .425rem .75rem;
   font-size: 0.8125rem;
   border-radius: .25rem;
   position: relative;
   flex: 1 1 auto;
   width: 1%;
   min-width: 0;
   color: #4b566b;
   background-color: #fff;
   background-clip: padding-box;
   border: 1px solid #d4d7e5;
   border-top-left-radius: 0;
   border-bottom-right-radius: 0;
}

.input-field:focus{
    outline: none;
}
</style>